export const TENANT_COM = 'com'
export const TENANT_AT = 'at'
export const TENANT_CH = 'ch'
export const TENANT_ES = 'es'
export const TENANT_FR = 'fr'
export const TENANT_IT = 'it'
export const TENANT_BASE = 'base'
export const TENANT_TEST = 'test'
